import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from '@hero/constants';

import { services } from '../../services';

export const useGetAutomationProducts = (code, options = {}) =>
  useQuery([QUERY_KEYS.useGetAutomationProductsKey, code], () => services.products(code), {
    staleTime: 20 * 1000,
    ...options
  });
